var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { extractHeadersFromAxiosResponse } from '../helpers/headers-helper';
import { httpDebugger } from './http.debugger';
import { retryHelper } from '../helpers/retry-helper';
export function getWithRetryAsync(instance, call, functionsConfig, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
        return yield runWithRetryAsync({
            retryAttempt: 0,
            url: call.url,
            retryStrategy: retryStrategyOptions,
            functionsConfig: functionsConfig,
            headers: (_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : [],
            call: (retryAttempt) => __awaiter(this, void 0, void 0, function* () {
                var _c, _d;
                httpDebugger.debugStartHttpRequest();
                const axiosResponse = yield instance.get(call.url, {
                    headers: getHeadersJson((_c = options === null || options === void 0 ? void 0 : options.headers) !== null && _c !== void 0 ? _c : [], false),
                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                    cancelToken: (_d = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _d === void 0 ? void 0 : _d.token
                });
                const response = {
                    data: axiosResponse.data,
                    rawResponse: axiosResponse,
                    headers: extractHeadersFromAxiosResponse(axiosResponse),
                    status: axiosResponse.status,
                    retryStrategy: {
                        options: retryStrategyOptions,
                        retryAttempts: retryAttempt
                    }
                };
                httpDebugger.debugSuccessHttpRequest();
                return response;
            })
        });
    });
}
export function postWithRetryAsync(instance, call, functionsConfig, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
        return yield runWithRetryAsync({
            retryAttempt: 0,
            url: call.url,
            retryStrategy: retryStrategyOptions,
            functionsConfig: functionsConfig,
            headers: (_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : [],
            call: (retryAttempt) => __awaiter(this, void 0, void 0, function* () {
                var _c, _d;
                httpDebugger.debugStartHttpRequest();
                const axiosResponse = yield instance.post(call.url, call.body, {
                    headers: getHeadersJson((_c = options === null || options === void 0 ? void 0 : options.headers) !== null && _c !== void 0 ? _c : [], false),
                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                    // required for uploading large files
                    // https://github.com/axios/axios/issues/1362
                    maxContentLength: 'Infinity',
                    maxBodyLength: 'Infinity',
                    cancelToken: (_d = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _d === void 0 ? void 0 : _d.token
                });
                const response = {
                    data: axiosResponse.data,
                    rawResponse: axiosResponse,
                    headers: extractHeadersFromAxiosResponse(axiosResponse),
                    status: axiosResponse.status,
                    retryStrategy: {
                        options: retryStrategyOptions,
                        retryAttempts: retryAttempt
                    }
                };
                httpDebugger.debugSuccessHttpRequest();
                return response;
            })
        });
    });
}
export function putWithRetryAsync(instance, call, functionsConfig, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
        return yield runWithRetryAsync({
            retryAttempt: 0,
            url: call.url,
            retryStrategy: retryStrategyOptions,
            functionsConfig: functionsConfig,
            headers: (_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : [],
            call: (retryAttempt) => __awaiter(this, void 0, void 0, function* () {
                var _c, _d;
                httpDebugger.debugStartHttpRequest();
                const axiosResponse = yield instance.put(call.url, call.body, {
                    headers: getHeadersJson((_c = options === null || options === void 0 ? void 0 : options.headers) !== null && _c !== void 0 ? _c : [], false),
                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                    // required for uploading large files
                    // https://github.com/axios/axios/issues/1362
                    maxContentLength: 'Infinity',
                    maxBodyLength: 'Infinity',
                    cancelToken: (_d = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _d === void 0 ? void 0 : _d.token
                });
                const response = {
                    data: axiosResponse.data,
                    rawResponse: axiosResponse,
                    headers: extractHeadersFromAxiosResponse(axiosResponse),
                    status: axiosResponse.status,
                    retryStrategy: {
                        options: retryStrategyOptions,
                        retryAttempts: retryAttempt
                    }
                };
                httpDebugger.debugSuccessHttpRequest();
                return response;
            })
        });
    });
}
export function patchWithRetryAsync(instance, call, functionsConfig, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
        return yield runWithRetryAsync({
            retryAttempt: 0,
            url: call.url,
            retryStrategy: retryStrategyOptions,
            functionsConfig: functionsConfig,
            headers: (_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : [],
            call: (retryAttempt) => __awaiter(this, void 0, void 0, function* () {
                var _c, _d;
                httpDebugger.debugStartHttpRequest();
                const axiosResponse = yield instance.patch(call.url, call.body, {
                    headers: getHeadersJson((_c = options === null || options === void 0 ? void 0 : options.headers) !== null && _c !== void 0 ? _c : [], false),
                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                    // required for uploading large files
                    // https://github.com/axios/axios/issues/1362
                    maxContentLength: 'Infinity',
                    maxBodyLength: 'Infinity',
                    cancelToken: (_d = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _d === void 0 ? void 0 : _d.token
                });
                const response = {
                    data: axiosResponse.data,
                    rawResponse: axiosResponse,
                    headers: extractHeadersFromAxiosResponse(axiosResponse),
                    status: axiosResponse.status,
                    retryStrategy: {
                        options: retryStrategyOptions,
                        retryAttempts: retryAttempt
                    }
                };
                httpDebugger.debugSuccessHttpRequest();
                return response;
            })
        });
    });
}
export function deleteWithRetryAsync(instance, call, functionsConfig, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
        return yield runWithRetryAsync({
            retryAttempt: 0,
            url: call.url,
            retryStrategy: retryStrategyOptions,
            functionsConfig: functionsConfig,
            headers: (_b = options === null || options === void 0 ? void 0 : options.headers) !== null && _b !== void 0 ? _b : [],
            call: (retryAttempt) => __awaiter(this, void 0, void 0, function* () {
                var _c, _d;
                httpDebugger.debugStartHttpRequest();
                const axiosResponse = yield instance.delete(call.url, {
                    headers: getHeadersJson((_c = options === null || options === void 0 ? void 0 : options.headers) !== null && _c !== void 0 ? _c : [], false),
                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                    // required for uploading large files
                    // https://github.com/axios/axios/issues/1362
                    maxContentLength: 'Infinity',
                    maxBodyLength: 'Infinity',
                    cancelToken: (_d = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _d === void 0 ? void 0 : _d.token
                });
                const response = {
                    data: axiosResponse.data,
                    rawResponse: axiosResponse,
                    headers: extractHeadersFromAxiosResponse(axiosResponse),
                    status: axiosResponse.status,
                    retryStrategy: {
                        options: retryStrategyOptions,
                        retryAttempts: retryAttempt
                    }
                };
                httpDebugger.debugSuccessHttpRequest();
                return response;
            })
        });
    });
}
export function createCancelToken() {
    let canceler;
    const token = new axios.CancelToken((c) => {
        // An executor function receives a cancel function as a parameter
        canceler = c;
    });
    return {
        cancel: (cancelMessage) => canceler(`${retryHelper.requestCancelledMessagePrefix}: ${cancelMessage !== null && cancelMessage !== void 0 ? cancelMessage : 'User cancel'}`),
        token: token
    };
}
function runWithRetryAsync(data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield data.call(data.retryAttempt);
        }
        catch (error) {
            const retryResult = retryHelper.getRetryErrorResult({
                error: error,
                retryAttempt: data.retryAttempt,
                retryStrategy: data.retryStrategy
            });
            if (retryResult.canRetry) {
                httpDebugger.debugRetryHttpRequest();
                // wait time before retrying
                yield new Promise((resolve) => setTimeout(resolve, retryResult.retryInMs));
                if (data.functionsConfig.logErrorsToConsole) {
                    console.warn(`Retry attempt '${data.retryAttempt + 1}' from a maximum of '${retryResult.maxRetries}' retries. Request url: '${data.url}'`);
                }
                // retry request
                return yield runWithRetryAsync({
                    call: data.call,
                    retryStrategy: data.retryStrategy,
                    retryAttempt: data.retryAttempt + 1,
                    url: data.url,
                    functionsConfig: data.functionsConfig,
                    headers: data.headers
                });
            }
            // sanitize the error before logging / re-throwing so the authorization token is not leaked
            const sanitizedError = sanitizeError(error, data.headers);
            if (data.functionsConfig.logErrorsToConsole) {
                console.error(`Executing '${data.url}' failed. Request was retried '${data.retryAttempt}' times.`, sanitizedError);
            }
            throw sanitizedError;
        }
    });
}
const redactedValue = 'redacted';
const maxRedactionDepth = 10;
/**
 * Returns the caller-supplied 'authorization' header value(s), which are the secret token(s) to
 * scrub from errors. Note: if a consumer sets the authorization token on the axios instance defaults
 * instead of passing it via 'options.headers', it is not known here and cannot be redacted.
 */
function getSecretHeaderValues(headers) {
    return headers
        .filter((header) => header.header.toLowerCase() === 'authorization')
        .map((header) => header.value)
        // skip empty values - splitting on an empty string would corrupt every string
        .filter((value) => typeof value === 'string' && value.length > 0);
}
function redactStringValue(value, secrets) {
    let result = value;
    for (const secret of secrets) {
        if (result.includes(secret)) {
            result = result.split(secret).join(redactedValue);
        }
    }
    return result;
}
/**
 * Walks the object graph (cycle- and depth-guarded) replacing every occurrence of a secret with the
 * redacted placeholder in place.
 *
 * Traversal is breadth-first, not depth-first: axios error graphs contain multiple paths to the same
 * underlying object (e.g. on a transport-level failure, both 'error.request._currentRequest' and a
 * much longer route through 'error.request._options...') and only the shortest one is guaranteed to
 * stay within 'maxRedactionDepth'. BFS visits every object for the first (and only) time via its
 * shortest path from 'target', so the depth guard is never tripped by a longer alternate route to an
 * object that is actually shallow enough to redact.
 */
function redactSecretsInPlace(target, secrets) {
    if (target === null || typeof target !== 'object') {
        return;
    }
    const seen = new WeakSet([target]);
    let frontier = [{ value: target, depth: 0 }];
    while (frontier.length > 0) {
        const next = [];
        for (const { value: item, depth } of frontier) {
            const container = item;
            // Reflect.ownKeys (not Object.keys) so symbol-keyed and non-enumerable properties are
            // also scrubbed - e.g. Node's ClientRequest keeps the outgoing headers (incl. the token)
            // under the Symbol(kOutHeaders) property, which Object.keys does not enumerate.
            for (const key of Reflect.ownKeys(item)) {
                let value;
                try {
                    value = container[key];
                }
                catch (_a) {
                    // accessing the property threw (e.g. a getter) - skip it
                    continue;
                }
                if (typeof value === 'string') {
                    const redacted = redactStringValue(value, secrets);
                    if (redacted !== value) {
                        try {
                            container[key] = redacted;
                        }
                        catch (_b) {
                            // property is read-only - skip it
                        }
                    }
                }
                else if (value &&
                    typeof value === 'object' &&
                    depth + 1 <= maxRedactionDepth &&
                    !seen.has(value)) {
                    seen.add(value);
                    next.push({ value, depth: depth + 1 });
                }
            }
        }
        frontier = next;
    }
}
/**
 * If 'error' is an axios error, redacts every occurrence of the caller's authorization token (taken
 * from 'headers') throughout the error, replacing it with a redacted placeholder. Non-axios errors
 * and errors with no known token are returned unchanged. This prevents the authorization token from
 * leaking via console logs or the re-thrown error. All other axios properties are preserved.
 */
function sanitizeError(error, headers) {
    if (!axios.isAxiosError(error)) {
        return error;
    }
    const secrets = getSecretHeaderValues(headers);
    if (secrets.length === 0) {
        return error;
    }
    redactSecretsInPlace(error, secrets);
    return error;
}
function getHeadersJson(headers, addContentTypeHeader) {
    const headerJson = {};
    headers.forEach((header) => {
        headerJson[header.header] = header.value;
    });
    if (addContentTypeHeader) {
        // add default content type header if not present
        const contentTypeHeader = headers.find((m) => m.header.toLowerCase() === 'Content-Type'.toLowerCase());
        if (!contentTypeHeader) {
            headerJson['Content-Type'] = 'application/json';
        }
    }
    return headerJson;
}
//# sourceMappingURL=http.functions.js.map